import { ReactComponent as CalendarIcon } from 'img/icons/mobile/calendar.svg';
import { ReactComponent as CloudIcon } from 'img/icons/mobile/cloud.svg';
import { ReactComponent as FileIcon } from 'img/icons/mobile/file.svg';
import { ReactComponent as FolderMoveInIcon } from 'img/icons/mobile/folderMoveIn.svg';
import { ReactComponent as CloseLinkAccessIcon } from 'img/icons/mobile/linkAccess.svg';

import { FileInfoRecord } from './useItems.types';

export const fileInfoItems: FileInfoRecord = {
    filename: {
        id: 'filename',
        section: 'Название',
        Icon: FileIcon,
    },
    uploadDate: {
        id: 'uploadDate',
        section: 'Добавлено',
        Icon: CalendarIcon,
    },
    removeDate: {
        id: 'removeDate',
        section: 'Удалено',
        Icon: CalendarIcon,
    },
    size: {
        id: 'size',
        section: 'Размер',
        Icon: CloudIcon,
    },
    share: {
        id: 'share',
        section: 'Настроить',
        Icon: CloseLinkAccessIcon,
        rightIcon: 'right',
    },
    direction: {
        id: 'direction',
        section: 'Расположение',
        Icon: FolderMoveInIcon,
        rightIcon: 'right',
    },
    originalPlace: {
        id: 'originalPlace',
        section: 'Исходное расположение',
        Icon: FolderMoveInIcon,
        rightIcon: 'right',
    },
};
